import { useEffect, useState } from "react";
import { IDecorationTech } from "../types/data.interface";
import useAxios from "../utils/useAxios";
import { URL } from "../libraries/http/url";
import { PageableDTO } from "../types/pageable";
import { AxiosInstance } from "axios";
import { Predicates } from "../libraries/predicates/predicates";

type SearchParams = {
  search?: string;
};

type DecorTechResponse = PageableDTO<IDecorationTech[]> | IDecorationTech[];

export const fetchDecorTech = async ({
  search,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const searchParams = URL.createSearchParams({
      search,
      limit: 50,
    });

    const response = await axios.get<DecorTechResponse>(
      `/product-master/decoration-technology/?${searchParams.toString()}`,
    );

    return Predicates.parsePageableReponseToType(response).map(
      (decorTech: IDecorationTech) => {
        return decorTech.id != "0"
          ? decorTech
          : { id: decorTech.id, name: "Not Applicable" };
      },
    );
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useDecorTech({ search }: SearchParams) {
  const axios = useAxios();
  const [data, setData] = useState<IDecorationTech[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchDecorTech({
        search,
        axios,
      });

      setData(response);
      setIsLoading(false);
    };

    getData();
  }, [search]);

  return { data, isLoading };
}
